import { getScrollContainer } from './getScrollContainer';
import { Scroller } from './Scroller';
import { ScrollValues } from './ScrollValues';

type GetScrollManagerArgs = {
  controller: AbortController;
  isAutoScroll?: boolean;
  target?: Element | null;
};

export const getScrollManager = ({
  controller,
  isAutoScroll,
  target,
}: GetScrollManagerArgs) => {
  if (!isAutoScroll) return defaultScrollManager;
  const scrollContainer = getScrollContainer(target);
  if (!scrollContainer) return defaultScrollManager;
  return {
    scrollValues: new Scroller(scrollContainer, controller).scrollValues,
  };
};

const defaultScrollManager = Object.freeze({
  scrollValues: Object.freeze({
    currentScrollTop: 0,
    currentScrollLeft: 0,
    deltaTop: 0,
    deltaLeft: 0,
  }),
}) as { scrollValues: ScrollValues };
